import axios from 'axios'


const local = 'http://localhost:53471/api/'
const production = 'https://www.sifrovacihra.cz/api/'

const host = window.location.href.includes('localhost') ? local : production

const GameId = 'ZKR2024'

interface IAxiosPostParams {
    data: any,
    params: any,
    path: string,
    token? :string
}

export const post = async ({data, params, path, token }: IAxiosPostParams): Promise<any> => {

    let config = {
        params,
        headers: {
            'Game': GameId,
            'Auth': token
        },


    };

    return await axios.post(host + path, data, config)
        .then((res) => {
            console.log(res)
            return {
                status: res.status,
                data: res.data
            }
        })
        .catch(
            e => {
                console.log(e)
                return {
                    status: e.response.status,
                    data: e.response.data
                }
            }
        )
}

interface IAxiosGetParams {
    params: any,
    path: string,
    token?: string
}
export const get = async ({ params, path, token }: IAxiosGetParams): Promise<any> => {

    let config = {
        params,
        headers: {
            'Game': GameId,
            'Auth': token
        },


    };

    return await axios.get(host + path, config)
        .then((res) => {
            return {
                status: res.status,
                data: res.data
            }
        })
        .catch(
            e => {
                console.log(e)
                console.log(e.status)
                return {
                    status: e.response.status,
                    data: e.response.data
                }
            }
        )
}
